import React from 'react';

import {svgIconWrapper} from '../svg-icon-wrapper';

import MessageSolid from './icon-message-solid.svg';

// @ts-expect-error
function SvgComponent(props) {
    const validProps = Object.assign({}, props);
    delete validProps.styles;

    return <MessageSolid {...validProps} />;
}
SvgComponent.iconName = 'message-icon-solid';

/**
 * @deprecated This is a legacy icon
 */
export const MessageIconSolid = svgIconWrapper(SvgComponent);
